import React, { useState, useContext, useEffect, } from "react";
import { Box, Button, TextField, Typography, IconButton, Grid, Select, MenuItem } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { createOrder, modifyOrder, OneClickTrading, } from "../../../api/request/dashboard/dashboard";
import { ThemeContext } from "../../../context/ThemeContext";
import { setOrderResponse } from "../../../store/Slices/symbolSlice";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import AskValue from "../../../components/global/BidAsk/AskValue";
import BidValue from "../../../components/global/BidAsk/BidValue";
import BuyLimit from "../../../components/modal/trading/components/BuyLimit";
import SellLimit from '../../../components/modal/trading/components/SellLimit'
import BuyStop from '../../../components/modal/trading/components/BuyStop'
import SellStop from '../../../components/modal/trading/components/SellStop'
import { setAmountForSymbol } from "../../../store/Slices/amountSlice";
import { setEditOrderDetail, setTradeModalOpen } from "../../../store/Slices/globalSymbolSlice";
import { addJournalLog } from "../../../components/tab/tabview/journal/addJournalLog";
import { getCookies } from '../../../services/Cookies'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from "react-router-dom";

const TradeOrderModal = ({ closeModal, onClose, showCloseButton = true, symbol = null }) => {
    const { t } = useTranslation()
    // const [amount, setAmount] = useState(100);
    const [comment, setComment] = useState("");
    const [disablePlaceorder, setDisablePlaceorder] = useState(true)
    const { darkMode } = useContext(ThemeContext)
    const { globalSymbol, globalSymbolID } = useSelector(state => state.globalSymbol)
    const editOrderDetail = useSelector((state) => state.globalSymbol.editOrderDetail);
    const [orderType, setOrderType] = useState(!symbol ? editOrderDetail?.side || "instantExecution" : "instantExecution");
    const [stopLoss, setStopLoss] = useState(!symbol ? editOrderDetail?.stopLoss || null : null);
    const [takeProfit, setTakeProfit] = useState(!symbol ? editOrderDetail?.takeProfit || null : null);
    const selectedSymbol = useSelector((state) => state.symbol.selectedSymbol)
    const { accountId: accountID } = useSelector(state => state.accountSummary);
    const [symbolId, setSymbolId] = useState(symbol || editOrderDetail?.symbolId || globalSymbolID || globalSymbol?.id);
    // const isEditMode = !symbol ? editOrderDetail || false : false
    const isEditMode = !symbol && !!editOrderDetail?.id;

    const navigate = useNavigate()
    const dispatch = useDispatch();
    const { symbols } = useSelector(state => state.watchlist)
    const symbolData = symbols[symbolId] || {};
    const allSymbolParams = useSelector((state) => state.symbol.allSymbolParams);
    const symbolParameterData = allSymbolParams?.[symbolId] || null;
    const [price, setPrice] = useState(null);
    const [volume, setVolume] = useState(null);
    const username = getCookies('username')

    const decimalPlaces = 2;
    const inputVal = useSelector((state) =>
        state?.amount?.[symbolId] ?? symbolParameterData?.minimumAmountPerDeal ?? 0.01
    );

    useEffect(() => {
        setSymbolId(symbol || editOrderDetail?.symbolId || globalSymbolID || globalSymbol?.id);
        setOrderType(!symbol ? editOrderDetail?.side || "instantExecution" : "instantExecution")
        setStopLoss(!symbol ? editOrderDetail?.stopLoss || null : null)
        setTakeProfit(!symbol ? editOrderDetail?.takeProfit || null : null)
    }, [editOrderDetail?.symbolId, symbol, globalSymbolID, globalSymbol?.id])


    const isMultipleOfStep = (value, step) => {
        if (!step) return false;
        const ratio = value / step;
        const nearestInt = Math.round(ratio);
        return Math.abs(ratio - nearestInt) < 1e-8;
    };

    const increaseAmount = () => {
        const step = symbolParameterData?.minimumAmountPerDeal || 0.1;
        setVolume(prev => {
            const newVal = (parseFloat(prev) + step).toFixed(decimalPlaces);
            if (symbolParameterData?.maximumAmountPerDeal >= newVal) {
                dispatch(setAmountForSymbol({ symbolId, amount: parseFloat(newVal) }));
                return newVal;
            } else {
                return parseFloat(prev).toFixed(decimalPlaces)
            }
        })
    }
    const decreaseAmount = () => {
        const step = symbolParameterData?.minimumAmountPerDeal || 0.1;
        setVolume(prev => {
            const newVal = (parseFloat(prev) - step).toFixed(decimalPlaces);
            if (symbolParameterData?.minimumAmountPerDeal <= newVal) {
                dispatch(setAmountForSymbol({ symbolId, amount: parseFloat(newVal) }));
                return newVal
            } else {
                return parseFloat(prev).toFixed(decimalPlaces)
            }
        })
    }
    const handleChange = (e) => {
        const value = e.target.value
        const desimals = value.split('.')?.[1]
        if (!desimals) {
            dispatch(setAmountForSymbol({ symbolId, amount: parseFloat(value) }));
            setVolume(value);
            return;
        }
        if (desimals.length <= decimalPlaces) {
            dispatch(setAmountForSymbol({ symbolId, amount: parseFloat(value) }));
            setVolume(value)
        }
    }
    const handleBlur = (e) => {
        const value = parseFloat(e.target.value);
        if (!value) {
            setVolume(symbolParameterData?.minimumAmountPerDeal)
            return;
        }
        setVolume(value.toFixed(decimalPlaces));
    };

    const handleBuy = async () => {
        if (!accountID) {
            toast.error("Account ID not available.");
            return;
        }
        if (volume < symbolParameterData?.minimumAmountPerDeal || volume > symbolParameterData?.maximumAmountPerDeal) {
            return toast.error(`Invalid Amount`);
        }
        // Check for step mismatch before sending to backend
        if (!isMultipleOfStep(volume, symbolParameterData?.minimumAmountPerDeal)) {
            toast.error(`Amount must be a multiple of ${symbolParameterData?.minimumAmountPerDeal}`);
            return;
        }

        try {
            const orderPayload = {
                accountId: Number(accountID),
                symbolId: symbolId,
                amount: volume,
                side: 1,
                comment: comment || "Order Trigger",
            };

            const response = await OneClickTrading(orderPayload);

            if (response?.status === 200) {
                dispatch(setOrderResponse(response.data));
                // toast.success(`Trade opened: ID #${response.data.id}, ${symbolData.name} at ${response.data.openPrice} Buy, Amount: ${orderPayload.amount}`);
                handleClose();
            } else {
                const backendError = response?.data?.message || "Order failed. Please try again.";
                toast.error(backendError);
            }

        } catch (error) {
            console.error("Error placing order:", error);
            const errorMessage = error?.response?.data?.message || error?.message || "Failed to place order.";
            toast.error(errorMessage);
        }
    };

    const handleSell = async () => {
        if (!accountID) {
            toast.error("Account ID not available.");
            return;
        }

        if (volume < symbolParameterData?.minimumAmountPerDeal || volume > symbolParameterData?.maximumAmountPerDeal) {
            return toast.error(`Invalid Amount`);
        }
        if (!isMultipleOfStep(volume, symbolParameterData?.minimumAmountPerDeal)) {
            toast.error(`Amount must be a multiple of ${symbolParameterData?.minimumAmountPerDeal}`);
            return;
        }

        const orderPayload = {
            accountId: Number(accountID),
            symbolId: symbolId,
            amount: volume,
            side: -1,
            comment: comment || "Order Trigger",

        };

        try {
            const response = await OneClickTrading(orderPayload);

            if (response?.status === 200) {
                dispatch(setOrderResponse(response.data));

                // toast.success(`Trade opened: ID #${response.data.id} , ${symbolData.name} at ${response.data.openPrice} Sell, Amount: ${orderPayload.amount}`);
                handleClose();
            } else {
                const backendError = response?.data?.message || "Order failed. Please try again.";
                toast.error(backendError);
            }
        } catch (error) {
            console.error("Error placing sell order:", error);
            const errorMessage = error?.response?.data?.message || error.message || "Failed to place order.";
            toast.error(errorMessage);
        }
    };

    const handleClose = () => {
        console.log('close');
        dispatch(setEditOrderDetail(null))
        onClose();
    };
    const handleOrderTypeChange = (event) => {
        setOrderType(event.target.value);
        setPrice("");
    };

    const handlePriceChange = (isIncrease) => {
        setPrice((prev) => {
            let currentPrice = parseFloat(prev);
            if (isNaN(currentPrice)) {
                currentPrice = symbolData?.ask ?? 0;
            }
            const step = 1 / Math.pow(10, symbolData?.digits || 2);
            const priceChange = isIncrease ? step : -step;
            const newPrice = Math.max(0, currentPrice + priceChange);

            return newPrice.toFixed(symbolData?.digits)
        });
    };

    const handlePlaceOrder = async () => {
        if (!accountID) {
            toast.error("Account ID not available.");
            return;
        }
        if (volume <= 0) {
            toast.error("Invalid amount");
            return;
        }
        try {
            const orderPayload = {
                accountId: Number(accountID),
                symbolId: symbolId,
                amount: volume,
                type: Number(orderType),
                price: price,
                stopLoss: stopLoss,
                takeProfit: takeProfit,
                comment: comment || "No Comment",
            };
            const response = await createOrder(orderPayload);
            if (response?.status === 200) {
                dispatch(setOrderResponse(response.data)); // Dispatch the response to the Redux store
                // toast.success("Order placed successfully!")
                // toast.success(`Trade opened: ID #${response.data.id} , ${symbolData.name} at ${response.data.price}, Amount: ${response.data.amount}`);

                handleClose();
            } else {
                console.error("Order failed:", response);
                toast.error(response)
            }
        } catch (error) {
            console.error("Error placing order:", error);
            const errorMessage = error?.response?.data?.message || error.message || "Failed to place order.";
            toast.error(errorMessage);
        }
    };
    const isInstantExecution = orderType === "instantExecution";

    const handleEditOrder = async () => {
        const payload = {
            id: editOrderDetail?.id,
            accountId: editOrderDetail?.accountId,
            price: price,
            amount: volume,
            stopLoss: stopLoss,
            takeProfit: takeProfit,
            comment: comment,
        };

        try {
            const response = await modifyOrder(payload);
            // toast.success(`Order updated: ID #${editOrderDetail?.id} ${symbolData?.name} at ${response.data.price}, Amount: ${response.data.amount}`);

            dispatch(setTradeModalOpen(false));
            dispatch(setEditOrderDetail(null));

        } catch (error) {
            const errMsg = error?.response?.data?.message || error?.message || "Failed to update order.";
            toast.error(errMsg);
            addJournalLog('updatedOrderError', `Updated Order: #${editOrderDetail.id} failure: ${errMsg}, Account ${username}: ${accountID}.
`);
        }
    };

    useEffect(() => {
        if (isEditMode && editOrderDetail?.id && symbolParameterData) {
            setPrice(editOrderDetail?.price ?? 0);
            setVolume(editOrderDetail?.amount ?? symbolParameterData?.minimumAmountPerDeal);
            setStopLoss(editOrderDetail?.stopLoss ?? "");
            setTakeProfit(editOrderDetail?.takeProfit ?? "");
            setComment(editOrderDetail?.comment ?? "");
        }
    }, [isEditMode, editOrderDetail, symbolParameterData]);


    useEffect(() => {
        if (!isEditMode) {
            setVolume(inputVal);
        }
    }, [decimalPlaces, symbolId, inputVal, isEditMode]);

    const symbolColor = useSelector(state => state.updateSymbol.symbols?.[symbolId]);

    const askColorClass = symbolColor?.askColor === 'down' ? '#E03C23' : symbolColor?.askColor === 'up' ? '#1176ED' : '#9e9e9e';
    const bidColorClass = symbolColor?.bidColor === 'down' ? '#E03C23' : symbolColor?.bidColor === 'up' ? '#1176ED' : '#9e9e9e';
    return (

        <Box display="flex" flexDirection="column" height="100vh">
            <Box display="flex" alignItems="center" justifyContent="space-between" px={2} py={1}>
                <Box display="flex" alignItems="center">
                    <IconButton onClick={onClose}><ArrowBackIosNewIcon fontSize="small" onClick={() => navigate('/quote')} /></IconButton>
                    <Typography fontSize={18} fontWeight={600} ml={1}>{symbolData?.name}</Typography>
                </Box>
            </Box>      <Grid container spacing={1} sx={{ overflow: 'auto', height: '100%' }}>
                <Grid item xs={12} display={'flex'} justifyContent={'center'}>
                    <Box px={2} sx={{ width: "100%", bgcolor: darkMode ? "var(--background-color)" : 'var(--white)', fontSize: "0.7rem" }}>
                        <Box mt={2}>
                            <Grid container spacing={2}>
                                <Grid container item xs={12} spacing={0.5} alignItems="center">
                                    <Grid item xs={2}>
                                        <Box sx={{ height: '56px', borderTopLeftRadius: 4, borderTopRightRadius: 4 }} bgcolor={bidColorClass} color="#fff" py={2} textAlign="center">
                                            <Typography fontSize={12} fontWeight={500}>{t("bid")}</Typography>
                                        </Box>
                                    </Grid>

                                    <Grid item xs={8}>
                                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", }}>
                                            <Typography sx={{ fontSize: '0.65rem', color: darkMode ? 'var(--lightText)' : "var(--black)", }}>{t('amount')}-({t('lot')})</Typography>
                                            <Typography variant="caption" align="right" sx={{ fontSize: '0.6rem', color: darkMode ? 'var(--lightText)' : "var(--black)", }}>{`${t('min')}: ${symbolParameterData?.minimumAmountPerDeal}, ${t('max')}: ${symbolParameterData?.maximumAmountPerDeal}`}</Typography>

                                        </Box>
                                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", border: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, overflow: "hidden" }}>
                                            <IconButton onClick={() => decreaseAmount(-symbolParameterData?.minimumAmountPerDeal)}
                                                disabled={volume <= symbolParameterData?.minimumAmountPerDeal} sx={{ borderRight: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, borderRadius: 0, border: "none" }}>
                                                <RemoveIcon fontSize="small" sx={{ fontSize: '1rem', color: darkMode ? 'var(--lightText)' : "var(--black)", }} />
                                            </IconButton>
                                            <TextField fullWidth onBlur={handleBlur} type='number' value={volume} size="small" onChange={(e) => handleChange(e)} inputProps={{
                                                min: symbolParameterData?.minimumAmountPerDeal,
                                                max: symbolParameterData?.maximumAmountPerDeal,
                                                step: symbolParameterData?.minimumAmountPerDeal
                                                , style: { textAlign: "center", fontSize: '0.9rem' }
                                            }} sx={{ width: 120, textAlign: "center", "& .MuiOutlinedInput-notchedOutline": { border: "none" }, color: darkMode ? 'var(--lightText)' : "var(--black)", }} />
                                            <IconButton onClick={() => increaseAmount(symbolParameterData?.minimumAmountPerDeal)}
                                                disabled={volume >= symbolParameterData?.maximumAmountPerDeal} sx={{ borderLeft: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}`, borderRadius: 0, border: "none" }}>
                                                <AddIcon fontSize="small" sx={{ fontSize: '1rem', color: darkMode ? 'var(--lightText)' : "var(--black)", }} />
                                            </IconButton>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Box sx={{ height: '56px', borderTopLeftRadius: 4, borderTopRightRadius: 4 }} bgcolor={askColorClass} color="#fff" py={2} textAlign="center">
                                            <Typography fontSize={12} fontWeight={500}>{t("ask")}</Typography>
                                        </Box>
                                    </Grid>
                                </Grid>

                                <Grid container item xs={12} spacing={2.2} sx={{ '& > .MuiGrid-item': { pt: 0 } }}>
                                    <Grid item xs={6}>
                                        <Box bgcolor={bidColorClass} color="#fff" p={2} sx={{ borderBottomRightRadius: 4, borderTopRightRadius: 4 }}>
                                            <Typography fontSize={18} fontWeight={700} textAlign="center">
                                                <BidValue symbolId={symbolId} digits={symbolData.digits} newOrder={true} />
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Box bgcolor={askColorClass} color="#fff" p={2} sx={{ borderBottomLeftRadius: 4, borderTopLeftRadius: 4 }}>
                                            <Typography fontSize={18} fontWeight={700} textAlign="center">
                                                <AskValue symbolId={symbolId} digits={symbolData.digits} newOrder={true} />
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>

                        <Box sx={{ display: "flex", p: 1, flexDirection: 'column' }} >
                            <Typography sx={{ fontSize: '0.75rem', color: darkMode ? 'var(--lightText)' : "var(--black)", }}>{t('type')}</Typography>

                            <Select value={orderType} onChange={handleOrderTypeChange} sx={{ fontSize: '0.75rem', "&:hover .MuiOutlinedInput-notchedOutline": { border: "none", }, "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: "none", }, border: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}` }}  >
                                <MenuItem value="instantExecution" sx={{ fontSize: '0.75rem' }}>{t('InstantExecution')}</MenuItem>
                                <MenuItem value="1" sx={{ fontSize: '0.75rem' }}>{t("BuyLimit")}</MenuItem>
                                <MenuItem value="-1" sx={{ fontSize: '0.75rem' }}>{t('SellLimit')}</MenuItem>
                                <MenuItem value="2" sx={{ fontSize: '0.75rem' }}>{t('BuyStop')}</MenuItem>
                                <MenuItem value="-2" sx={{ fontSize: '0.75rem' }}>{t('SellStop')}</MenuItem>
                            </Select>
                        </Box>

                        <Box sx={{ p: 1, }}>
                            {orderType == "1" && !isInstantExecution && (<BuyLimit isMobile={true} setDisablePlaceorder={setDisablePlaceorder} handlePriceChange={handlePriceChange} price={price} setPrice={setPrice} symbolId={symbolId} stopLoss={stopLoss} setStopLoss={setStopLoss} takeProfit={takeProfit} setTakeProfit={setTakeProfit} />)}
                            {orderType == "-1" && (<SellLimit isMobile={true} setDisablePlaceorder={setDisablePlaceorder} handlePriceChange={handlePriceChange} price={price} setPrice={setPrice} symbolId={symbolId} stopLoss={stopLoss} setStopLoss={setStopLoss} takeProfit={takeProfit} setTakeProfit={setTakeProfit} />)}
                            {orderType == "2" && (<BuyStop isMobile={true} setDisablePlaceorder={setDisablePlaceorder} handlePriceChange={handlePriceChange} price={price} setPrice={setPrice} symbolId={symbolId} stopLoss={stopLoss} setStopLoss={setStopLoss} takeProfit={takeProfit} setTakeProfit={setTakeProfit} />)}
                            {orderType == "-2" && (<SellStop isMobile={true} setDisablePlaceorder={setDisablePlaceorder} handlePriceChange={handlePriceChange} price={price} setPrice={setPrice} symbolId={symbolId} stopLoss={stopLoss} setStopLoss={setStopLoss} takeProfit={takeProfit} setTakeProfit={setTakeProfit} />)}


                            <Box sx={{ mb: 1 }}><Typography sx={{ fontSize: '0.75rem', color: darkMode ? 'var(--lightText)' : "var(--black)", }}>{t('comment')}</Typography>
                                <TextField fullWidth size="small" className="custom-textfield " value={comment} onChange={(e) => setComment(e.target.value)} /> </Box>
                            {isInstantExecution ? (
                                <Box sx={{ display: "flex", justifyContent: 'space-around', m: 1, fontSize: 15, fontWeight: 500 }}>
                                    <BidValue symbolId={symbolData?.id} digits={symbolData.digits} />
                                    <AskValue symbolId={symbolData?.id} digits={symbolData.digits} />
                                </Box>
                            ) : (null)}

                            {isInstantExecution ? (
                                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                    <Button variant="contained" fullWidth sx={{ borderRadius: 0, bgcolor: '#E03C23' }} onClick={handleSell} > {t('sell')}</Button>
                                    <Button variant="contained" fullWidth sx={{ borderRadius: 0, bgcolor: '#1176ED' }} onClick={handleBuy} > {t('buy')}</Button>
                                </Box>
                            ) : (
                                <Button variant="contained" fullWidth sx={{ borderRadius: 0 }} onClick={isEditMode ? handleEditOrder : handlePlaceOrder} disabled={disablePlaceorder}> {isEditMode ? t("updateOrder") : t("placeOrder")}</Button>
                            )}
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default TradeOrderModal;
